<template>
    <MainContent
        title="Packs de eventos"
    >
        <template v-slot:header>
            <b-button
                size="sm"
                :to="{ name: 'back.packs-events.create' }"
            >
                Crear nuevo pack de eventos
            </b-button>
        </template>
        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                    <b-table
                        :items="packs.data"
                        :fields="fields"
                        empty-text="No hay ningún pack de eventos"
                        responsive
                    >
                        <template #cell(status)="data">
                            {{ data.item.status | formatear_estado_evento }}
                        </template>
                        <template #cell(opciones)="data">
                            <b-dropdown 
                                :id="'dropdown-' + data.item.id" text="Opciones" 
                                class="m-md-2"
                                v-if="data.item.estado != 1"
                            >
                                <b-dropdown-item 
                                :to="{ name: 'back.packs-events.show', params: { pack_id: data.item.id } }"
                                >
                                    Detalle
                                </b-dropdown-item>
                                <b-dropdown-item 
                                    :to="{ name: 'back.packs-events.show.editar', params: { pack_id: data.item.id } }"
                                >
                                    Editar
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                    </b-table>
                    <b-pagination
                        v-if="packs.meta"
                        v-model="packs.meta.current_page"
                        :total-rows="packs.meta.total"
                        :per-page="per_page"
                        @change="getPacks"
                    />
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
import MainContent from '../../../components/backend/components/MainContent.vue'

export default {
    data() {
        return {
            packs: {
                data: []
            },
            per_page: 10,
            fields: ['name', 'address', 'status', 'opciones']
        }
    },
    created() {
        this.getPacks()
    },
    methods: {
        getPacks(page) {
            const params = {
                filters : {
                    per_page: this.per_page,
                    page: page
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.index'), params).then(res => {
                this.packs = res.data;
            });
        }
    },
    components: {
        MainContent
    }
}
</script>